module.exports = __webpack_public_path__ + "img/hohlsaum_brillantgelb_farbnr119.5624bfa4.jpg";